import React, { useReducer } from 'react';
import { BrowserRouter as Router, Redirect } from "react-router-dom";
import { Auth } from 'aws-amplify';
import ClearCache from "react-clear-cache";
import axios from './utils/axios';
import Template from './Containers/Template/index';
import Routes from './Routes/index';
import { AppContext, INITIAL_APP_STATE, appReducer } from './Contexts/App/AppContext';

/**********************Interceptor to set authentication Token in every request************************/
const instantiateEnv = () => {
  return axios.interceptors.request.use(config => {
    return Auth.currentSession()
      .then(session => {
        config.headers.common.Authorization = session.idToken.jwtToken;
        return Promise.resolve(config);
      })
      .catch(err =>
        <Redirect to={{
          pathname: '/login'
        }} />
      );
  });
}
/******************************************************************************************************/

function App(props) {
  instantiateEnv();
  const [app, appDispatcher] = useReducer(appReducer, INITIAL_APP_STATE);
  return (
    <>
      <ClearCache>
        {({ isLatestVersion, emptyCacheStorage }) => (
          <>
            {!isLatestVersion && emptyCacheStorage()}
            <AppContext.Provider
              value={{
                ...app,
                dispatch: appDispatcher,
              }}
            >
              <Router>
                <Routes />
              </Router>
            </AppContext.Provider>
          </>
        )}
      </ClearCache>
    </>
  );
}

export default App;